import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { StationsState } from '../../types';

import {
  updateStationsPriceReportSettings as updateStationsPriceReportSettingsOperation
} from '../operations/updateStationsPriceReportSettings';

import { STATUS_LOADING } from 'common/constants';

export const updateStationsPriceReportSettings = (
  builder: ActionReducerMapBuilder<StationsState>
) => builder
  .addCase(updateStationsPriceReportSettingsOperation.pending, (state) => {
    state.stationsPriceReportSettings.updatingStatus = STATUS_LOADING.load;
  })
  .addCase(updateStationsPriceReportSettingsOperation.fulfilled, (state, { payload }) => {
    state.stationsPriceReportSettings.updatingStatus = STATUS_LOADING.done;
    state.stationsPriceReportSettings.data = payload;
  })
  .addCase(updateStationsPriceReportSettingsOperation.rejected, (state) => {
    state.stationsPriceReportSettings.updatingStatus = STATUS_LOADING.error;
  });
